const PAGE_TOUR_SEEN_PREFIX = 'phoebe:page-tour:seen';

export function getPageTourSeenStorageKey(
    scope: string,
    userId: string,
): string {
    return `${PAGE_TOUR_SEEN_PREFIX}:${scope}:${userId}`;
}

export function isPageTourSeen(seenStorageKey: string): boolean {
    try {
        return window.localStorage.getItem(seenStorageKey) !== null;
    } catch {
        // Treat unavailable storage as seen so the tour never nags on every
        // visit.
        return true;
    }
}

export function markPageTourSeen(seenStorageKey: string): void {
    try {
        window.localStorage.setItem(seenStorageKey, new Date().toISOString());
    } catch {
        // Session-only dismissal when storage is unavailable.
    }
}

export function getTrainingPageTourScope(
    pageId: string,
    organizationId: string,
): string {
    return `training:${pageId}:${organizationId}`;
}
